<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper" ref="formContainer">
      <!-- Page Content -->
      <div class="content container-fluid">
        <!-- Page Header -->
        <employees-header
          :title="title"
          :path="path"
          :text="text"
          :text1="text1"
          @clearFormData="clearFormData"
          @clearEmployeeData="clearEmployeeData"
        />
        <!-- /Page Header -->

        <!-- Search Filter -->
        <search-filter @reload-data="searchData" :employee_list2="employee_list2" ></search-filter>
        <!-- /Search Filter -->

        <div class="row staff-grid-row" v-if="Employees.length > 0">
          <div
            class="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3"
            v-for="item in Employees"
            :key="item?.id"
          >
            <div class="profile-widget">
              <div class="profile-img">
                <router-link :to="'profile/' + item?.id" class="avatar"
                  ><img
                    v-if="item?.avatar && item?.avatar != null"
                    :src="getEmployeeAvatar(item?.avatar)"
                    alt="User Image"
                    @error="handleImageError(item)"
                  />
                  <img
                    v-else
                    :src="require(`@/assets/img/profiles/${defaultAvatar}`)"
                    alt="User Image"
                  />
                </router-link>
              </div>
              <div
                class="dropdown profile-action"
                v-if="hasEditPermission || hasDeletePermission"
              >
                <a
                  class="action-icon dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  ><i class="material-icons">more_vert</i></a
                >
                <div class="dropdown-menu dropdown-menu-right">
                  <a
                    v-if="hasEditPermission"
                    class="dropdown-item"
                    data-bs-toggle="modal"
                    data-bs-target="#emp_edit_and_profile_update"
                    @click="employee(item)"
                    ><i class="fa-solid fa-pencil m-r-5"></i> Edit</a
                  >
                  <a
                    v-if="hasDeletePermission"
                    class="dropdown-item"
                    data-bs-toggle="modal"
                    data-bs-target="#delete_employee"
                    @click="employee(item)"
                    ><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a
                  >
                </div>
              </div>
              <h4 class="user-name m-t-10 mb-0 text-ellipsis">
                <router-link :to="'profile/' + item?.id"
                  >{{ item?.first_name }} {{ item?.last_name }}</router-link
                >
              </h4>
              <div class="small text-muted">
                {{
                  item?.department && item?.department.name
                    ? item?.department.name
                    : "-"
                }}
              </div>
              <div class="small text-muted">
                {{
                  item?.designation && item?.designation.name
                    ? item?.designation.name
                    : "-"
                }}
              </div>
            </div>
          </div>
        </div>
        <div v-else class="col-12 text-center no-data-container">
          <div class="ant-empty-image">
            <svg
              width="64"
              height="41"
              viewBox="0 0 64 41"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g transform="translate(0 1)" fill="none" fill-rule="evenodd">
                <ellipse
                  fill="#f5f5f5"
                  cx="32"
                  cy="33"
                  rx="32"
                  ry="7"
                ></ellipse>
                <g fill-rule="nonzero" stroke="#d9d9d9">
                  <path
                    d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
                  ></path>
                  <path
                    d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                    fill="#fafafa"
                  ></path>
                </g>
              </g>
            </svg>
          </div>
          <p style="color: #00000040; margin-bottom: 0px">No data</p>
        </div>
      </div>
      <div class="row" v-if="Employees.length > 0">
        <div class="col-12 text-center">
          <a-pagination
            @change="onChange"
            v-model:current="pagination.current"
            v-model:pageSize="pagination.pageSize"
            :total="pagination.total"
            show-less-items
          ></a-pagination>
        </div>
      </div>
      <!-- /Page Content -->

      <employee-model
        :employeeData="employeeData"
        @reloadEmp="loadCommonData"
        :clearForm="clearForm"
        :clearEMP="clearEMP"
      ></employee-model>
      <employee-edit-model
        :employeeData="employeeData"
        @reload-data="loadCommonData"
        :clearEMP="clearEMP"
      ></employee-edit-model>
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { notification } from "ant-design-vue";
import axios from "axios";

export default {
  data() {
    return {
	  employee_list2: [],
      clearEMP: false,
      clearForm: false,
      title: "Employee",
      path: "Dashboard",
      text: "Employee",
      text1: "Add Employee",
      employeeData: null,
      defaultAvatar: "avatar-01.jpg",
      refreshModel: true,
      hasEditPermission: null,
      hasDeletePermission: null,
      hasReadPermission: null,
      pagination: {
        total: 0,
        current: 0,
        pageSize: 12,
      },
      Employees: [],
      current: 1,
      currentFilters: {
        name: null,
        employee_id: null,
        designation_id: null,
        status: null,
        dept_id: null,
      },
    };
  },
  methods: {
    ...mapActions(["fetchEmployees", "setEmployeeData"]),
    clearEmployeeData() {
      this.clearEMP = false;
      this.$nextTick(() => {
        this.clearEMP = true;
      });
    },
    clearFormData() {
      this.clearForm = false;
      this.$nextTick(() => {
        this.clearForm = true;
      });
    },
    employee(employee) {
      this.refreshModel = false;
      this.setEmployeeData(employee);

      this.$nextTick(() => {
        this.employeeData = employee;
        this.refreshModel = true;
      });
    },
    getEmployeeAvatar(avatar) {
      return `${process.env.VUE_APP_IMAGE_BASE_URL}${avatar}`;
    },
    handleImageError(item) {
      item.avatar = null;
      item.avatar = `assets/img/profiles/${this.defaultAvatar}`;
    },
    searchData(searchData) {
      var params = {
        params: { per_page: this.pagination.pageSize },
      };
      this.loadCommonData(params, searchData);
    },
    loadCommonData(params, searchData = null) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      if (params == null) {
        params = {
          params: {
            per_page: this.pagination.pageSize,
            page: this.pagination.current,
          },
        };
      }

      let getQuery = "/employee";
      let queryParams = {
        ...params.params,
        ...this.currentFilters,
      };

      if (searchData != null) {
        this.currentFilters = {
          name: searchData.name,
          employee_id: searchData.employee_id,
          designation_id: searchData.designation_id,
          status: searchData.status,
          dept_id: searchData.dept_id,
        };
        queryParams = { ...queryParams, ...this.currentFilters };
      }

      axios
        .get(getQuery, { params: queryParams })
        .then((response) => {
          loader.hide();
          this.pagination.total = response.data.data.record.total;
          this.pagination.current = response.data.data.record.current_page;
          this.pagination.pageSize = response.data.data.record.per_page;

          this.Employees = response.data.data.record.data || [];
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
	loadAllEmployees2(params) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/employees/allemployees", params)
        .then((response) => {
          //	console.log(response.data.data.data);

          //this.employee_list = response.data.data;

          for (let i = 0; i < response.data.data.length; i++) {
            this.employee_list2.push({
              id: response.data.data[i].id,
              text:
                response.data.data[i].first_name +
                " " +
                response.data.data[i].last_name,
            });
          }

          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    onChange(current) {
      this.pagination.current = current;

      var params = {
        params: { per_page: this.pagination.pageSize, page: current },
      };

      this.loadCommonData(params);
    },
  },
  async created() {
    this.$store
      .dispatch("userPermissions", { module: "employee", action: "read" })
      .then((response) => {
        this.hasReadPermission = null;
        this.$nextTick(() => {
          this.hasReadPermission = response === "true";

          if (!this.hasReadPermission) {
            notification.open({
              message: "You don't have access to this page!",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            var user_role = window.localStorage.getItem("role");

            if (user_role && user_role.includes("Employee")) {
              this.$router
                .push({ name: "employee-dashboard" })
                .catch((error) => {});
            } else {
              this.$router
                .push({ name: "admin-dashboard" })
                .catch((error) => {});
            }
          }
        });
      });

    this.$store
      .dispatch("userPermissions", { module: "employee", action: "write" })
      .then((response) => {
        this.hasEditPermission = null;
        this.$nextTick(() => {
          this.hasEditPermission = response === "true";
        });
      });

    this.$store
      .dispatch("userPermissions", { module: "employee", action: "delete" })
      .then((response) => {
        this.hasDeletePermission = null;
        this.$nextTick(() => {
          this.hasDeletePermission = response === "true";
        });
      });

    var params = {
      params: { per_page: this.pagination.pageSize },
    };

    this.loadCommonData(params);
	
	this.loadAllEmployees2([]);
  },
};
</script>
